import { render, staticRenderFns } from "./open-vip.vue?vue&type=template&id=4130a7e7&scoped=true"
import script from "./open-vip.vue?vue&type=script&lang=js"
export * from "./open-vip.vue?vue&type=script&lang=js"
import style0 from "./open-vip.vue?vue&type=style&index=0&id=4130a7e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4130a7e7",
  null
  
)

export default component.exports